import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useMakeResponsiveStyles } from 'kineticUtils/hooks/useMakeResponsiveStyles';
import { MutableRefObject } from 'react';

const useCRUDStyles = makeStyles(({ spacing, palette }) => {
  return createStyles({
    formWrapper: {
      width: '100%',
      margin: `0 ${spacing(2)} 0 ${spacing(2)}`,
    },
    content: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& form': {
        height: '100%',
        width: '100%',
      },
      paddingLeft: spacing(2),
    },
    tabs: {
      borderBottom: `${spacing(0.1)} solid ${palette.divider}`,
      position: 'relative',
      flex: 1,
    },
    restrictionButton: {
      top: 0,
      position: 'absolute',
      right: spacing(2),
    },
    config: {
      justifyContent: 'space-around',
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
    },
    card: {
      width: '33%',
      margin: `0 ${spacing(2)} 0 ${spacing(2)}`,
    },
    tabPanel: {
      padding: spacing(2),
      flex: 1,
      height: '100%',
    },
    fullHeight: {
      height: '100%',
    },
  });
});

export default useCRUDStyles;

export const useResponsiveStyles = (containerRef: MutableRefObject<HTMLElement | null>) => {
  return useMakeResponsiveStyles(containerRef, {
    tabsWrapper: {
      base: {
        maxWidth: '100%',
      },
      lg: {
        maxWidth: '90%',
      },
      md: {
        maxWidth: '50%',
      },
      sm: {
        maxWidth: '25%',
      },
    },
  });
};
